const STORAGE_KEY = 'pita_session';
const DEFAULT_TTL_MS = 30 * 60 * 1000; // 30 minutes

interface StoredSession {
  id: string;
  expiresAt: number;
}

export function getSessionId(ttlMs: number = DEFAULT_TTL_MS): string {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const stored: StoredSession = JSON.parse(raw);
      if (stored.id && stored.expiresAt > Date.now()) {
        // Valid session — refresh TTL (sliding window)
        stored.expiresAt = Date.now() + ttlMs;
        localStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
        return stored.id;
      }
    }
  } catch {
    // Corrupted data or storage unavailable — fall through to create new
  }

  const newSession: StoredSession = {
    id: crypto.randomUUID(),
    expiresAt: Date.now() + ttlMs,
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newSession));
  } catch {
    // localStorage full or disabled — still return the generated ID
  }
  return newSession.id;
}
